import { useFormContext } from 'react-hook-form'

import type {
  ProductFlagFormValues,
  SettableProductFlagField,
} from '@/definitions/productFlags'

import { descendantsOf } from '../utils/flagDependencies'

/**
 * Stages one switch, taking everything that sits behind it off with it.
 *
 * A product flag switched off leaves the ones that depend on it unable to work, so they
 * go off in the same gesture rather than being left on and inert — and the whole chain
 * goes, not just the product flags directly beneath. Switching one on brings nothing
 * with it: what a practice gets is the operator's call, and the switches for those
 * product flags are reachable the moment their requirement is on.
 */
export const useFlagChange = () => {
  const { setValue } = useFormContext<ProductFlagFormValues>()

  return (field: SettableProductFlagField, checked: boolean) => {
    setValue(field, checked, { shouldDirty: true })

    if (checked) {
      return
    }
    for (const dependent of descendantsOf(field)) {
      setValue(dependent, false, { shouldDirty: true })
    }
  }
}
